import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../commonv3/api/RemoteResourceV3';
import { NotificationDeliveryIndexView, NotificationDeliveryToken } from '../../types/notification_deliveries';
import { NotificationDeliveryApis } from '../../apis/notification_delivery';
import { NotificationIconState } from '../navigation/states/NotificationIconState';

export class NotificationDeliveryShowPageState {
    @observable notificationDelivery: RemoteResourceV3<NotificationDeliveryIndexView> = RemoteResourceV3.loading();
    @observable token: NotificationDeliveryToken = null;
    @observable
    confirmedNotificationDelivery: RemoteResourceV3<NotificationDeliveryIndexView> = RemoteResourceV3.loading();
    @observable notificationIconState = null;
    constructor(notificationIconState: NotificationIconState) {
        this.notificationIconState = notificationIconState;
    }

    @action.bound
    async init(token: NotificationDeliveryToken) {
        this.token = token;
        await this.reloadNotificationDelivery();
        await this.confirmNotificationDelivery();
        await this.updateNotificationDeliveiesCount();
    }

    async reloadNotificationDelivery() {
        return await updateRemoteResourceV3(
            this.notificationDelivery,
            (v) => (this.notificationDelivery = v),
            () => NotificationDeliveryApis.show(this.token)
        );
    }

    async confirmNotificationDelivery() {
        await NotificationDeliveryApis.confirmNotificationDelivery(this.token);
    }

    async updateNotificationDeliveiesCount() {
        this.notificationIconState.reloadNotificationDeliveriesCount();
    }
}
